import { PlanovacIframe } from "@components/widgets/PlanovacIframe";
import { withCan } from "@src/utils/components/permissions";

export default withCan({ do: "integration_forecasting" }, PlanovacIframe);
